import ExtjsReact from "../../../common/utils/ExtReact";

class ExtjsRowTemplatePanel extends ExtjsReact {
    renderExtjsCmp() {
        let me = this;
        setTimeout(() => {
            me.getRowTemplatePanel(this.renderTo)
            me.cmp.setTemplateBody(me.props.templateBody);
            me.cmp.setTemplateAttachment(me.props.attatchmentData);
        }, me.props.delayedRender ? 300 : 0)
    }

    getRowTemplatePanel = (renderTo) => {
        var me = this,
            props = me.props;

        return me.cmp = Ext.create("TL.list.RowTemplatePanel", {
            renderTo: renderTo,
            // list: this.list,
            cls: "notification_mail_body",
            columns: props.columns, // TODO: get rid of this config and use this.list
            listName: props.list.name, // TODO: get rid of this config and use this.list
            // templateBody: props.templateBody,
            // attachmentData: props.attachmentData,
            templateTitle: "",
            hasTemplateTitle: true,
            listId: props.list.id,
            viewId: 0,
            // isTestMailButton: false,
            hasAttachment: false,
            autoHeight: false,
            fixedEditor: true,
            isEditorMinimal: true,
            isTestMailButton: true,
            isHelperFunctionsHidden: true,
            isSystemColumns: false,
            //heightOfPanel: 500,
            width: 900,
            listeners: {
                "templatevalue": function (template) {
                    this.templateBody = template;
                }, scope: this
            }
        });
    }

    getValue = () => this.cmp.getValue()

}

export default ExtjsRowTemplatePanel;